const colors = {
    blue: '#003AFF',
    white: '#',
    light_gray: '#9E9E9E',
    dark_gray: '#3C3C3C',
}


export { colors }